import React from "react";

//Router
import {
  Outlet
} from "react-router-dom";

function Account() {

  return (
    <div className="d-flex flex-column">
      <div className="header flex-separate border-bottom">
        <span>
          Minha conta
        </span>
      </div>

      <div className="account dashboard__container">
        <Outlet />
      </div>
    </div>
  );
}

export default Account;